/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import PropTypes from 'prop-types';

import { t } from 'i18next';
import { Trans } from 'react-i18next';

import {
  Box, styled, IconButton, Link, Tooltip, Typography,
} from '@mui/material';

import { formatDateFromNow } from '../../../../../utils/date';

import Grid from '../../../../common/Grid';
import StatusCell from '../../../../common/Table/StatusCell';

import { convertNotificationText } from './utils';
import { SeverityIcon } from './SeverityIcon';

import { styles } from './styles';

const NotificationRaw = ({
  title,
  className,
  notifications,
  readNotification,
  viewNotification,
}) => (
  <Box className={className}>
    <Typography className="dn-notification-title">
      {t(title)}
    </Typography>
    <Box className="dn-notifications-container">
      <Grid className="dn-notifications" container>
        {
          notifications.map((notification) => {
            const {
              id, read, severity, createdAt, status,
            } = notification;

            const handleViewDetail = () => viewNotification(id);
            const handleReadUnRead = () => readNotification(id, read);

            const { text, textOptions } = convertNotificationText(notification);

            return (
              <Grid key={id} item xs={12}>
                <Box className={`dn-flex-between dn-flex-middle dn-notification ${!read && 'dn-background'}`}>
                  <Box className="dn-flex-middle">
                    {
                      status ? (
                        <StatusCell className="dn-notifications-status-icon" row={{ status }} displayText={false} />
                      ) : (
                        <SeverityIcon severity={severity} />
                      )
                    }
                    <Typography className="dn-summary">
                      <Trans t={t}>
                        {t(text, textOptions)}
                      </Trans>
                      <span className="dn-date">
                        {formatDateFromNow(createdAt)}
                        .
                      </span>
                      <Link onClick={handleViewDetail} className="dn-detail">
                        {t('View detail')}
                      </Link>
                    </Typography>
                  </Box>
                  <Box>
                    <Tooltip title={t(read ? 'Mark as unread' : 'Mark as read')}>
                      <IconButton onClick={handleReadUnRead} className={read ? 'dn-read' : 'dn-unread'}>
                        <Box />
                      </IconButton>
                    </Tooltip>
                  </Box>
                </Box>
              </Grid>
            );
          })
        }
      </Grid>
    </Box>
  </Box>
);

NotificationRaw.propTypes = {
  className: PropTypes.string,
  notifications: PropTypes.array,
  title: PropTypes.string,
  readNotification: PropTypes.func,
  viewNotification: PropTypes.func,
};

const Notification = styled(NotificationRaw)(styles);

Notification.propTypes = NotificationRaw.propTypes;

export default Notification;
